import React, { Component } from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'

class PriceListingLabel extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            item: this.props.value || null,
            className: this.props.className || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            item: nextProps.value || null,
            className: nextProps.className || '',
        })
    }

    renderPrice(billingMethod) { 
        switch (billingMethod) {
            case "one-time":
                return <FormattedNumber
                    style="currency"
                    currency={this.state.item.currency}
                    value= {this.props.isPriceLevelSelected && this.state.item.productPriceUnitPrice ? this.state.item.productPriceUnitPrice : this.state.item.oneTimeMinimumPrice}
                />
            case "monthly":
                return <FormattedMessage
                    id="common.pricing.label.per_month"
                    defaultMessage="{price} per month"
                    values={{
                        price: <FormattedNumber
                            style="currency"
                            currency={this.state.item.currency}
                            value={this.state.item.monthlyMinimumPrice}
                        />
                    }}
                />
            case "yearly":
                return <FormattedMessage
                    id="common.pricing.label.per_year"
                    defaultMessage="{price} per year"
                    values={{
                        price: <FormattedNumber
                            style="currency"
                            currency={this.state.item.currency}
                            value={this.state.item.yearlyMinimumPrice}
                        />
                    }}
                />
        }
    }

    render() {
        if (!this.state.item) {
            return ''
        }
        let price = []
        for (let index in this.state.item.billingMethods) {
            const billingMethod = this.state.item.billingMethods[index]
            switch (this.state.item.type) {
                case 'matrix-parent':
                case 'assembly':
                    price.push(<p key={index} className={"m-0 " + this.state.className}><FormattedMessage
                        id="quote.edit.add_modal.product_list.price_from_label"
                        defaultMessage="from {price}"
                        values={{
                            'price': this.renderPrice(billingMethod)
                        }}
                    /></p>)
                    break
                default:
                    price.push(<p key={index} className={"m-0 " + this.state.className}>{this.renderPrice(billingMethod)}</p>)
                    break
            }
        }
        

        return price
    }
}

export default PriceListingLabel





// WEBPACK FOOTER //
// ./src/product/pricelistinglabel.component.jsx